<template>
  <optional-field :enabled.sync="enabled" :name="field.name">
    <v-combobox v-model="localData"
                :label="label"
                :append-outer-icon="!field.required ? 'block' : ''"
                @click:append-outer="disable"
                hide-details
                chips
                deletable-chips
                hide-no-data
                clearable
                multiple>
    </v-combobox>
  </optional-field>
</template>

<script>
import Field from '@/mixins/JsonEditorField'
import OptionalField from './OptionalField'

export default {
  name: 'JsonTags',
  components: { OptionalField },
  mixins: [Field]
}
</script>
